// eslint-disable-next-line
import React from 'react';
import pt from 'prop-types';
import path from 'ramda/src/path';
import _ from 'underscore';
import DatePicker from 'react-datepicker';
import moment from 'moment';
import Select from 'react-select';
import { Modal } from 'react-bootstrap';
import { Link } from 'react-router-dom'

import Formatting from '../../../utils/Formatter';
let DATE_FORMAT = Formatting.FORMATS.apiDateFormat
import util from '../../lib/util';
let dimensionsOk = util.dimensionsOk
import Snack from '../../../common/components/SnackMessage';
import Overlay from '../../../common/components/Overlay';
import FileUpload from '../components/UploadView';
import events from './manifest';
import Loader from '../../../common/components/notifications/Loader'

/*
{
    "channelName": "",
    "defaultImage": "<misc. assetID>",
    "beginDate": "YYYY-MM-DD",
    "language": "en",
    "ottTargets": ['roku', 'firestick', 'appletv'],
    "categories": [
        {
            "categoryID": "<cateogryID>",
            "defaultImage": "<misc. assetID>"
        }
    ],
    "persistentStreams": [
        {
            "persistentStreamID": "",
            "persistentDefaultImage": "<misc. assetID>"
        }
    ]
}
*/

function catsToOpts (cat) {
    return {
        value: cat.categoryID,
        label: cat.categoryName
    };
}

function feedsToOpts (feed) {
    return {
        value: feed.encoderID,
        label: feed.title
    };
}

function SuccessMessage (props) {
    return <div className="success-message">
        <div className="row">
            <div className="alert alert-success" role="alert">
                <span className="glyphicon glyphicon-ok"
                    aria-hidden="true"> </span>

                {' Your channel '}
                <em>{props.channel.channelName}</em>
                {' has been created. Next, '}

                <Link to={'/manage/ott/roku?id=' +
                    props.channel.ottChannelID}>
                    setup an OTT device
                </Link>
            </div>
        </div>

    </div>;
}

function OttEdit (props) {
    if (props.loading) {
        return <div className="ott-edit-channel">
            <Loader message="Loading" />
        </div>;
    }

    var className = 'ott-edit-channel container-fluid';
    var resolving = _(props.resolving).find(function (req) {
        return req.op === 'add' || req.op === 'edit';
    });

    return (<div className={className}>
        <Overlay active={resolving} />

        {
            props.addSuccess ?
                <SuccessMessage {...props} /> :
                content(props)
        }

        {!!props.choosingAssets ? (<Modal
            show={true}
            onHide={_.compose(
                props.push,
                events.closeAssetModal,
                _.constant(null)
            )}
        >

            <Modal.Header closeButton>
                <Modal.Title>Images</Modal.Title>
            </Modal.Header>

            <Modal.Body className="container-fluid">

                {
                    props.assets && props.assets.data.length > 0 ?
                    <ul className="list-unstyled row" style={{
                        padding: '1em'
                    }}>
                        {props.assets.data.map(function (asset) {
                            return <AssetImage
                                key={asset.assetID}
                                asset={asset}
                                onSelect={_.compose(
                                    props.push,
                                    (props.choosingAssets.categoryID ?
                                        events.selectCategoryImage :
                                        props.choosingAssets.encoderID ?
                                        events.selectStreamImage :
                                        events.chooseImage)
                                )}
                            />;
                        })}
                    </ul>:
                    <div className="alert alert-info">
                        You don't have any image assets
                    </div> 
                }

            </Modal.Body>

            <Modal.Footer>
                {
                 // @TODO this should be encapsulated in FileUpload.update
                 // or something like that, then nested in the main reducer
                }
                <FileUpload
                    onUploadStart={_.compose(
                        props.push,
                        events.startUpload
                    )}
                    progress={props.assetUploadProgress}
                    isUploading={props.assetUploadInProgress}
                    fileName={props.assetUploadName}
                />
            </Modal.Footer>

        </Modal>) : null}
    </div>);
}

function content (props) {
    var imageValid = dimensionsOk(800, 450, props.selectedDefaultImage);

    return <form className="row" onSubmit={_.compose(
        props.push,
        events.save,
        function (ev) {
            ev.preventDefault();
            return null;
        }
    )}>

        <div className="callout clearfix">
            <div className="col-sm-6">
                <div className="form-group" style={{
                    marginTop: '1em'
                }}>
                    <label>Channel type *</label>
                    {/* <label style={{ marginRight: '2em' }}>Channel type *</label>*/}

                    <label className="radio" style={{ paddingLeft: '2em' }}>
                        <input
                            type="radio"
                            onChange={_.compose(
                                props.push,
                                events.channelTypeChange,
                                _.constant('managed')
                            )}
                            checked={props.channelType === 'managed'}
                            value="managed" /> Managed
                    </label>

                    <label className="radio" style={{ paddingLeft: '2em' }}>
                        <input
                            type="radio"
                            onChange={_.compose(
                                props.push,
                                events.channelTypeChange,
                                _.constant('unmanaged')
                            )}
                            checked={props.channelType === 'unmanaged'}
                            value="unmanaged" /> DIY
                    </label>
                </div>
            </div>

            <div className="col-sm-6">
                <div className="alert alert-info">
                    {props.channelType === 'managed' ?
                        <p>$1000 one time fee, billed after the channel is approved</p> :
                        <p>Use your existing OTT accounts with this channel at no extra cost</p>
                    }
                </div>
            </div>
        </div>


        <div className="form-group">
            <label htmlFor="channelName">Channel name *</label>

            <p className="help-block">
                This name is used to identify your channel within Invintus,
                and is not visible to your audience
            </p>

            <input type="text" className="form-control"
                id="channelName"
                placeholder="Channel Name"
                value={props.channelName}
                onChange={_.compose(
                    props.push,
                    events.changeChannelName,
                    path(['target', 'value'])
                )}
            />
        </div>

        <div className="row">
            <div className="col-sm-6">
                <div className="form-group">
                    <div className="input-group">
                        <span className="input-group-addon">Start Date</span>
                        <DatePicker
                            onChange={_.compose(
                                props.push,
                                events.changeBeginDate,
                                function (ev) {
                                    return ev.format(DATE_FORMAT);
                                }
                            )}
                            showYearDropdown
                            showMonthDropdown
                            peekNextMonth
                            className="form-control"
                            dateFormat="MM/DD/YYYY"
                            selected={moment(props.selectedDate)}
                        />
                    </div>
                </div>
            </div>
        </div>


        {/*
        <div className="row">
             <div className="col-sm-12">
                 <div className="form-group form-inline">
                     <label style={{ marginRight: '2em' }}>
                         Target devices *
                     </label>

                     <label className="checkbox-inline">
                         <input name="ottTargets" value="roku" type="checkbox"
                             checked={_(props.targets).contains('roku')}
                             onChange={_.compose(
                                 props.push,
                                 events.changeTarget,
                                 _.constant('roku')
                             )}
                         /> Roku
                     </label>

                     <label className="checkbox-inline">
                         <input name="ottTargets" value="firestick" type="checkbox"
                             checked={_(props.targets).contains('firestick')}
                             onChange={_.compose(
                                 props.push,
                                 events.changeTarget,
                                 _.constant('firestick')
                             )}
                         /> Firestick
                     </label>

                     <label className="checkbox-inline">
                         <input name="ottTargets" value="'appletv'" type="checkbox"
                             checked={_(props.targets).contains('appletv')}
                             onChange={_.compose(
                                 props.push,
                                 events.changeTarget,
                                 _.constant('appletv')
                             )}
                         /> Apple TV
                     </label>

                 </div>
             </div>
        </div>
        */}

        <div className="form-group form-inline">
            <label htmlFor="channelImage" style={{ marginRight: '1em' }}>
                Channel image *
            </label>

            <button id="channelImage" className="btn btn-primary"
                onClick={_.compose(
                    props.push,
                    events.browseImages,
                    function (ev) {
                        ev.preventDefault();
                        return true;
                    }
                )}>
                Choose image
            </button>

            <p className="help-block">
                800 × 450 png/jpeg. This is the default thumbnail image for
                this channel, and will be seen by viewers
            </p>

            {
                props.selectedDefaultImage && !imageValid ?
                    <p className="text-danger">
                        Image should be 800 × 450
                    </p> :
                    null
            }
        </div>

        <div className="row">
            <div className="col-sm-4">
                {props.selectedDefaultImage ?
                    <img src={props.selectedDefaultImage.fileUrl}
                        className="img-responsive"
                    /> :
                    null
                }
            </div>
        </div>

        <div className="form-group form-inline" style={{ marginTop: '1em' }}>
            <label style={{ marginRight: '2em' }}>Channel sources</label>
            <p className="help-block">
                The selected event categories and live streams will be
                published on this channel
            </p>
        </div>

        <SourceSelect {...props} />

        <Snack
            isOpen={!!props.errors.length}
            message={(props.errors[0] || {}).message || ''}
            timeout={false}
            type="error"
            onClose={_.compose(
                props.push,
                events.shiftError
            )}
        />

        <ul className="list-inline list-unstyled text-right">
            <li>
                <button className="btn btn-primary" type="submit"
                    disabled={!props.isValid || !imageValid ||
                        !imagesAreValid(props)}
                >
                    Save
                </button>
            </li>
        </ul>

    </form>;
}

function imagesAreValid (props) {
    return (props.selectedCategories || props.selectedFeeds)
        .map(function (selected) {
            var asset = _(props.assets.data).findWhere({
                assetID: selected.defaultImage
            });
            return dimensionsOk(800, 450, asset);
        })
    ;
}
function imageIsValid (asset) {
    return asset.advancedDetails.image[0].width === 800 && asset.advancedDetails.image[0].height === 450;
}

function SourceSelect (props) {
    var imagesValid = imagesAreValid(props);
    // categories
    return (
      <div className='select-ott-sources'>
        <div className='form-group'>
          <label htmlFor='category-select'>Event categories</label>
          <Select
            id='category-select'
            multi
            options={props.categories.data.map(catsToOpts)}
            value={_(props.selectedCategories).map('categoryID')}
            onChange={_.compose(props.push, events.selectCategory)}
          />
        </div>

        <div className='row'>
          {props.selectedCategories.length || props.selectedFeeds.length ? (
            <div className='col-sm-12'>
              <p className='help-block'>Images should be 800 × 450 png/jpeg</p>
            </div>
          ) : null}
          <div className='image-listing'>
            {props.selectedCategories.map(function (cat, i) {
              var _cat = _(props.categories.data).findWhere({
                categoryID: cat.categoryID,
              })

              var src = (
                _(props.assets.data).findWhere({
                  assetID: cat.defaultImage || props.selectedDefaultImage,
                }) || {}
              ).fileUrl

              return (
                <ImageCard
                  key={i}
                  title={_cat.categoryName}
                  onAddImage={_.compose(
                    props.push,
                    events.browseImages,
                    function (ev) {
                      ev.preventDefault()
                      return {
                        categoryID: _cat.categoryID,
                      }
                    }
                  )}
                >
                  {src && !imagesValid[i] ? (
                    <p className='text-danger'>Image should be 800 × 450</p>
                  ) : src ? (
                    <img src={src} className='img-responsive' />
                  ) : (
                    <div className='text-center no-image'>
                      <em>no image</em>
                    </div>
                  )}
                </ImageCard>
              )
            })}
          </div>
        </div>

        <div className='form-group'>
          <label htmlFor='stream-select'>Persistent Streams</label>
          <Select
            id='stream-select'
            multi
            options={props.persistentStreams.data.map(feedsToOpts)}
            value={_(props.selectedFeeds).map('encoderID')}
            onChange={_.compose(props.push, events.selectFeed)}
          />
        </div>

        <div className='row'>
          <div className='image-listing'>
            {props.selectedFeeds.map(function (feed, i) {
              var _feed = _(props.persistentStreams.data).findWhere({
                encoderID: feed.encoderID,
              })

              const asset =
                _(props.assets.data).findWhere({
                  assetID: feed.defaultImage || props.selectedDefaultImage,
                }) || {}
              const imgSrc = asset && asset.fileUrl

              return (
                <ImageCard
                  key={i}
                  title={_feed.title}
                  image={imgSrc}
                  onAddImage={_.compose(
                    props.push,
                    events.browseImages,
                    function (ev) {
                      ev.preventDefault()
                      return { encoderID: _feed.encoderID }
                    }
                  )}
                >
                  {imgSrc && !imageIsValid(asset) ? (
                    <p className='text-danger'>Image should be 800 × 450</p>
                  ) : imgSrc ? (
                    <img src={imgSrc} className='img-responsive' />
                  ) : (
                    <div className='text-center no-image'>
                      <em>no image</em>
                    </div>
                  )}
                </ImageCard>
              )
            })}
          </div>
        </div>
      </div>
    )
}

function AssetImage (props) {
    var asset = props.asset;
    function click (ev) {
        ev.preventDefault();
        props.onSelect(props.asset);
    }
    if (asset.advancedDetails.image === undefined) {
        // asset needs image dimension info to be rendered
        return null
    }
    return <li className="col-sm-6 col-md-4 callout ott-asset-card">
        <img className="img-responsive" src={asset.fileUrl} alt={asset.name} />
        <ul className="list-unstyled">
            <li>{asset.name}</li>
            <li>{asset.advancedDetails.image[0].width} × {asset.advancedDetails.image[0].height}</li>
            <li className="text-right">
                <button className="btn btn-primary"
                    onClick={click}
                >
                    <span className="glyphicon glyphicon-ok" aria-hidden="true"></span>
                </button>
            </li>
        </ul>
    </li>;
}

function ImageCard (props) {
    return <div className="col-sm-4 ott-category-card">
        <div className="panel panel-default">

            <div className="panel-body" style={{ height: 'auto'}}>
                <div className="h5">{props.title}</div>
                {props.children}
            </div>

            <div className="panel-footer text-right">
                <button className="btn btn-primary" onClick={props.onAddImage}>
                    Add image
                </button>
                <p className="help-block">
                    This image will be a thumbnail representing this channel, visible to your audience
                </p>
            </div>

        </div>
    </div>;
}

ImageCard.propTypes = {
    onAddImage: pt.func.isRequired,
    title: pt.node
};

OttEdit.propTypes = {
    persistentStreams: pt.object.isRequired,
    categories: pt.object.isRequired,
    selectedCategories: pt.array.isRequired,
    selectedFeeds: pt.array.isRequired,
    choosingAssets: pt.any.isRequired
};

export default OttEdit;
